// eslint-disable-next-line
export const http = require('!raw-loader!./http.js').default

// eslint-disable-next-line
export const timer = require('!raw-loader!./timer.js').default

// eslint-disable-next-line
export const rng = require('!raw-loader!./rng.js').default

// eslint-disable-next-line
export const socket = require('!raw-loader!./socket.js').default
